import { FormInstance } from "@pankod/refine-antd";
import { IShootExecutionForm } from "components/forms/frm_shootexecution";
import dayjs, { Dayjs } from "dayjs";
import { IScheduleWindow } from "interfaces";

export function isWithinSchedule(
  date: Dayjs,
  schedule?: IScheduleWindow
): boolean {
  if (!schedule) return false;

  const dayOfWeek = date.day();
  const isHoliday = schedule.holidays.some(
    (h) => h.date === date.format("YYYY-MM-DD")
  );

  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
  const isNonWorkday = isHoliday || isWeekend;

  const start = isNonWorkday
    ? schedule.weekend_holiday_start
    : schedule.workday_start;
  const end = isNonWorkday
    ? schedule.weekend_holiday_end
    : schedule.workday_end;

  const startTime = dayjs(
    date.format("YYYY-MM-DD") + " " + start,
    "YYYY-MM-DD HH:mm"
  );
  const endTime = dayjs(
    date.format("YYYY-MM-DD") + " " + end,
    "YYYY-MM-DD HH:mm"
  );

  return (
    (date.isSame(startTime) || date.isAfter(startTime)) &&
    date.isBefore(endTime)
  );
}

function getDayStart(date: Dayjs, schedule: IScheduleWindow): Dayjs {
  const dayOfWeek = date.day();
  const isHoliday = schedule.holidays.some(
    (h) => h.date === date.format("YYYY-MM-DD")
  );

  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
  const isNonWorkday = isHoliday || isWeekend;

  const start = isNonWorkday
    ? schedule.weekend_holiday_start
    : schedule.workday_start;

  return dayjs(date.format("YYYY-MM-DD") + " " + start, "YYYY-MM-DD HH:mm");
}

export function getNextValidDateTime(
  date: Dayjs,
  duration: number,
  schedule: IScheduleWindow
): Dayjs {
  let nextDateTime = date.add(duration, "minute");

  while (true) {
    const dayOfWeek = nextDateTime.day();
    const isHoliday = schedule.holidays.some(
      // eslint-disable-next-line no-loop-func
      (h) => h.date === nextDateTime.format("YYYY-MM-DD")
    );

    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const isNonWorkday = isHoliday || isWeekend;

    const start = isNonWorkday
      ? schedule.weekend_holiday_start
      : schedule.workday_start;
    const end = isNonWorkday
      ? schedule.weekend_holiday_end
      : schedule.workday_end;

    const startTime = dayjs(
      nextDateTime.format("YYYY-MM-DD") + " " + start,
      "YYYY-MM-DD HH:mm"
    );
    const endTime = dayjs(
      nextDateTime.format("YYYY-MM-DD") + " " + end,
      "YYYY-MM-DD HH:mm"
    );

    if (nextDateTime.isSame(endTime) || nextDateTime.isAfter(endTime)) {
      nextDateTime = getDayStart(nextDateTime.add(1, "day"), schedule);
      continue;
    }

    if (nextDateTime.isBefore(startTime)) {
      nextDateTime = startTime;
      continue;
    }

    return nextDateTime;
  }
}

export const validateTemplateSchedule =
  (
    index: number,
    executionMinutes: number,
    form?: FormInstance<IShootExecutionForm>
  ) =>
  async (_: unknown, value: Dayjs | null) => {
    if (index === 0) return Promise.resolve();

    const previousDate: Dayjs | null = form?.getFieldValue([
      "templates_schedule",
      index - 1,
      "scheduled_datetime",
    ]);

    if (!previousDate) {
      return Promise.resolve();
    }

    if (!value) {
      return Promise.reject(
        new Error("Início do template deve ser preenchido.")
      );
    }

    const prevDateTime = previousDate.second(0);
    const currDateTime = value.second(0);

    const prevExecutionEnd = prevDateTime.add(executionMinutes, "minute");

    if (
      !currDateTime.isSame(prevExecutionEnd) &&
      !currDateTime.isAfter(prevExecutionEnd)
    ) {
      return Promise.reject(
        new Error("Início do template deve ocorrer após o término do anterior.")
      );
    }

    return Promise.resolve();
  };
